<template>
    <div>
        <p class="text-size-4 text-italic text-bold">
            Chico Rei é uma marca que alia criatividade e tecnologia para a produção de camisetas
            que geram impacto social através de suas vendas.
        </p>
        <p>
            Materializamos ideias que transmitem um estilo de vida permeado pela busca constante
            pelo novo. Somos inquietos, acreditamos na liberdade individual e temos o objetivo de
            dar possibilidades para pessoas interessantes se expressarem.
        </p>
        <p>
            Sempre investimos na diversidade para dialogar com pessoas das mais variadas tribos.
            Nosso objetivo é fazer com que a arte pule dos objetos e seja a conexão, que ela inicie
            diálogos e inspire o ciclo de criatividade.
        </p>
        <p>
            Tudo o que fazemos é pautado por verdade. Muito antes de falar, procuramos fazer um
            trabalho sólido que dê sustentação aos nossos discursos. Por aqui, o storydoing vem
            muito antes do storytelling. É isso o que movimenta a nossa paixão. E como diria Nelson
            Rodrigues, "sem paixão não dá nem pra chupar um picolé".
        </p>
        <p>
            Nosso objetivo é apresentar uma construção de dentro para fora: é a ponta do iceberg num
            conjunto de valores e atributos de marca que estão objetiva ou subjetivamente
            representados através de tudo o que produzimos e reproduzimos.
        </p>
        <p>
            Muito além de camisetas, vendemos histórias. Temos um custo-benefício que o cliente não
            encontrará em nenhum outro lugar. Nossas estampas são únicas e somos referência quando o
            assunto é criatividade. Nossas camisetas são sensacionais e têm uma qualidade incrível.
            Como se não bastasse, geram impacto social através de suas vendas. Falamos de Minas
            Gerais e de Brasil como nenhuma outra marca: basta olhar para os nossos parceiros para
            entender como estamos posicionados no mercado. Através de nossas estampas construímos
            narrativas que encantam os clientes, formando e fomentando uma comunidade bacaníssima.
            Essa é a Chico Rei ;)
        </p>
    </div>
</template>

<script>
    export default {
        name: 'BrandBookAbout',
    };
</script>
